import { ActionIcon, Anchor, List, Popover, Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import { Link } from 'wouter'

import { useDebugFlags, useDebugToolbar, useMst } from '#hooks/index'

import { FaIcon } from '../FaIcon'

export const FeatureFlags = observer(function FeatureFlags() {
  'use memo'

  const { user, currentOrg } = useMst()
  const debugFlags = useDebugFlags()
  const toolbar = useDebugToolbar()

  if (!user.staff || !currentOrg) return null

  const allFlags = [...currentOrg.betaFlags, ...debugFlags]
  const label = toolbar.isVisible ? 'Hide debug toolbar' : 'Show debug toolbar'

  return (
    <Popover position="right-end" shadow="md">
      <Popover.Target>
        <ActionIcon color="dark" variant="transparent">
          <FaIcon icon="fa-flag" />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown
        key={toolbar.isVisible ? 'toolbar-open' : 'toolbar-closed'}
      >
        <Text mb="xs">
          <Anchor component="button" type="button" onClick={toolbar.toggle}>
            {label}
          </Anchor>
        </Text>
        {allFlags.length ? (
          <>
            <Text mb="xs">
              The following feature flags are active for {currentOrg.name}
            </Text>
            <List mb="xs">
              {allFlags.map((flag) => (
                <List.Item key={flag}>{flag}</List.Item>
              ))}
            </List>
          </>
        ) : (
          <Text mb="xs">
            The current workspace {currentOrg.name} does not have any feature
            flags enabled
          </Text>
        )}
        <Text>
          <Link href={`/staff/workspaces/${currentOrg.id}`}>
            Edit feature flags
          </Link>{' '}
          for this workspace
        </Text>
      </Popover.Dropdown>
    </Popover>
  )
})
